import { render, staticRenderFns } from "./PeopleProfile.vue?vue&type=template&id=67337bf8&scoped=true&"
import script from "./PeopleProfile.vue?vue&type=script&lang=js&"
export * from "./PeopleProfile.vue?vue&type=script&lang=js&"
import style0 from "./PeopleProfile.vue?vue&type=style&index=0&id=67337bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67337bf8",
  null
  
)

export default component.exports